export class DocumentUploadData {
  model: string;
  model_id: number;
  subject: string;
  desription: string;
  type: string;
  data: {} | object;
}
